import Loader from "../../common/components/Loader";
import useTranslation from "../../common/translations";
import NoQuery from "./NoQuery";
import NoResults from "./NoResults";
import ResultsSections from "./ResultsSections";
import SearchErrorIcon from "./SearchErrorIcon";
import React from "react";
export default function SearchResults({ query, loading, error, groups, noResultSuggestions, isTypoFallback = false, recent, onClearRecent, onSelectRecentItem, onSelectSuggestion, }) {
    const { t } = useTranslation("site-search");
    if (loading) {
        return <Loader />;
    }
    if (error) {
        return (<div className={"flex flex-col items-center"}>
        <div>
          <SearchErrorIcon />
        </div>
        <div className={"text-lg font-semibold text-center"}>
          {t("search.error.title")}
        </div>
        <div className={"text-center mt-1"}>{t("search.error.subtitle")}</div>
      </div>);
    }
    const hasResults = groups.some((g) => g.items.length > 0);
    if (!query) {
        return (<NoQuery recent={recent} onClearRecent={onClearRecent} onSelectRecentItem={onSelectRecentItem}/>);
    }
    if (!hasResults) {
        return (<NoResults query={query} suggestions={noResultSuggestions} recent={recent} onClearRecent={onClearRecent} onSelectRecentItem={onSelectRecentItem} onSelectSuggestion={onSelectSuggestion}/>);
    }
    return (<ResultsSections groups={groups} onSelect={onSelectSuggestion} isTypoFallback={isTypoFallback}/>);
}
